module.exports = __webpack_public_path__ + "media/images/responsive/page_common/banner_stores/banner_stores_shinjuku@2x-d46634cffc8c591e4f3dae56b2913885.webp";